import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from './modal.service';
import { ModalSharedComponent } from './modal.component';

@NgModule({
    declarations: [
        ModalSharedComponent
    ],
    imports: [
        CommonModule,
        NgbModalModule
    ],
    exports: [
        ModalSharedComponent
    ],
    providers: [
        ModalService
    ]
})

export class ModalSharedModule {}
